import {macroConstants} from "_constants";

const INITIAL_STATE = {
    macros: [],
    fetchMacroLoading: false,
    fetchMacroError: '',

    selectedMacro: {}
};

export function macroReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case macroConstants.FETCH_MACRO_REQUEST:
            return { ...state, fetchMacroLoading: true };

        case macroConstants.FETCH_MACRO_SUCCESS:
            const newMacro = action.payload?.macro;
            const macroExists = state.macros.some(macro => macro.id === newMacro.id);
            return { ...state, macros: macroExists ? state.macros : [...state.macros, newMacro], fetchMacroLoading: false };

        case macroConstants.FETCH_MACRO_FAILURE:
            return { ...state, fetchMacroError: action.error, fetchMacroLoading: false };

        case macroConstants.CLEAR_MACROS:
            return { ...state, macros: [], fetchMacroError: '', fetchMacroLoading: false };

        default:
            return state;
    }
}